<template>
    <div class="publi">
        <title-header title="Publicações" class="mt-16"/>
        <div class="content">
            <Journal v-for="(journal, index) in journals" :key="index" :img="journal.capa" :descricao="journal.descricao" :download="journal.arquivo"/>
        </div>
        <div class="tabs">
            <button class="arrow" @click="previous"><</button>
            <button v-for="page in pages"
                    v-if="Math.abs(page - active) < 3 || page === lastPage || page === 1"
                    :key="page"
                    class="tab"
                    @click="onPageChange(page); active = page"
                    :class="{'bg-primary':page === active,
                    last: (page === lastPage && Math.abs(page - active) > 3),
                    first:(page === 1 && Math.abs(page - active) > 3)}"
            >
                {{ page }}
            </button>
            <button class="arrow" @click="next">></button>
        </div>
    </div>
</template>

<script>
    import TitleHeader from '../index/components/title-header';
    import Journal from './components/journal';

    import axios from 'axios';

    export default {
        name: 'page-publicacoes',
        components: {
            TitleHeader,
            Journal,
        },
        data() {
            return {
                journals: [],
                pages: [],
                active: 1,
                lastPage: 0,
            }
        },
        methods: {
            onPageChange(index) {
                axios.get('publicacoes?page=' + index)
                    .then(res => {
                        this.journals = res.data.publicacao.data
                    })
            },
            next() {
                if(this.active < this.lastPage) {
                    this.onPageChange(this.active + 1)
                    this.active += 1
                }
            },
            previous() {
                if(this.active > 1) {
                    this.onPageChange(this.active - 1)
                    this.active -= 1
                }
            }
        },
        created() {
            axios.get('publicacoes')
            .then(res => {
                this.journals = res.data.publicacao.data
                this.pages = res.data.publicacao.last_page
                this.lastPage = res.data.publicacao.last_page
            })
        }
    }
</script>

<style lang="scss" scoped>
    .publi {
        .content{
            @apply grid grid-cols-1 mx-auto mb-32 mt-16;
            max-width: 1600px;

            @media(min-width: 640px) {
                @apply grid-cols-2;
            }
            @media(min-width: 1024px) {
                @apply grid-cols-3;
            }
            @media(min-width: 1280px) {
                @apply grid-cols-4;
            }
        }
    }
    .tabs {
        @apply mx-auto text-center my-12;
        .tab {
            @apply px-2 rounded-md mx-1 text-base-gray;
            border: 0.5px solid #8e8e8e;
            @media(min-width: 640px) {
                @apply rounded-lg mr-3 py-1 px-3 font-medium text-xl text-base-gray;
                border: 1px solid #8e8e8e;
            }
        }
        .tab:hover{
            @apply bg-primary font-medium text-white outline-none border-primary;
        }
        .tab:focus {
            @apply text-white outline-none;
        }
        .tab.first::after {
            content:'...'
        }

        .tab.last::before {
            content:'...'
        }
        .arrow {
            @apply py-1 font-medium text-base text-base-gray;
            @media(min-width: 640px) {
                @apply mr-3 py-1 px-3 font-medium text-xl text-base-gray;
            }
        }
        .arrow:focus {
            @apply outline-none;
        }
    }
</style>
